export default {"src":"/_next/static/media/_ticket.1620f750.svg","height":24,"width":24};